import { Injectable } from '@angular/core'
import { BehaviorSubject, Subject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  // the map of uniqueKey to global search value
  private readonly valueMap: Map<string, string> = new Map<string, string>()
  // subject for notifying clients of the new map
  private readonly valueSubject = new BehaviorSubject<Map<string, string>>(this.valueMap)
  // subject to trigger a global search for a specific uniqueKey
  private readonly triggerSubject = new Subject<{ uniqueKey: string, value: string }>()

  /**
   * sets the global search value, without triggering a search
   */
  setValue (data: { uniqueKey: string, value: string }) {
    this.valueMap.set(data.uniqueKey, data.value)
    this.valueSubject.next(this.valueMap)
  }

  /**
   * gets the global search value, without triggering a search
   */
  getValue () {
    return this.valueSubject.asObservable()
  }

  /**
   * call for the execution of a search, will automatically set payload to current search value
   */
  setTrigger (uniqueKey: string) {
    const value = this.valueMap.get(uniqueKey) ?? ''
    this.triggerSubject.next({ uniqueKey: uniqueKey, value: value })
  }

  /**
   * subscription to detect for the execution of a search, will include the current search value for convenience
   */
  getTrigger () {
    return this.triggerSubject.asObservable()
  }
}
